import type { Transition, Variants } from 'motion/react';

// Shared easing/timing so every animated element in the app moves the same way.
export const EASE: Transition = { duration: 0.35, ease: [0.22, 1, 0.36, 1] };

// A screen's content fading + rising into place — used by AppLayout so every
// route change gets a consistent, subtle entrance without each screen wiring it up.
export const pageEnter: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: EASE },
};

// Parent wrapper for a grid/list whose children should reveal one after another
// rather than all at once.
export const staggerContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.05 } },
};

// Individual item inside a `staggerContainer`.
export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: EASE },
};

// Hover/tap feedback for clickable cards — a small lift and a small press-down.
export const cardHover = {
  whileHover: { y: -4 },
  whileTap: { scale: 0.98 },
  transition: EASE,
};

// Apple-style scroll reveal: an element fades + rises into place the first time it
// scrolls into view (not on mount). Pair with `viewportOnce` on a motion element's
// `whileInView`. Consumed by the <Reveal> component.
export const viewportReveal: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: EASE },
};

// Trigger the reveal once, slightly before the element is fully on screen, so it's
// already settled by the time the user reaches it.
export const viewportOnce = { once: true, amount: 0.2 } as const;

// Springier press for primary actions — a touch of physicality, à la Linear/Stripe.
export const pressSpring: Transition = { type: 'spring', stiffness: 400, damping: 25 };
